export default __webpack_public_path__ + "static/media/modal_grayHoodieGirl.66d4dbcc.png";